module.exports = __webpack_public_path__ + "static/friendship_house.45612db0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/friendship_house.jpg
// module id = 581
// module chunks = 35783957827783